
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import * as XLSX from "xlsx";
import excelFile from "../../assets/database.xlsx";
import styled from "styled-components";
import {
    useTable,
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";



const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
    return (
        <div style={{ marginBottom: "10px" }}>
            <input
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Search all columns..."
                style={{
                    padding: "5px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    width: "100%",
                }}
            />
        </div>
    );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
    column: { filterValue, setFilter, preFilteredRows, id },
}) => {
    const [isActive, setIsActive] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const options = useMemo(() => {
        const uniqueValues = Array.from(
            new Set(preFilteredRows.map((row) => row.values[id]))
        ).map((value) => ({ label: value, value }));
        return [{ label: "All", value: "" }, ...uniqueValues];
    }, [id, preFilteredRows]);

    // Handle icon click
    const handleIconClick = () => {
        setIsActive(!isActive);
    };

    const handleMultiSelectChange = (selectedOptions) => {
        const values = selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [];
        setFilter(values.length > 0 ? values : undefined);
    };

    return (
        <div style={{ alignItems: "center" }}>
            <div>
                <i
                    className="fa-solid fa-ellipsis-vertical"
                    onClick={handleIconClick}
                    style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "#AC0000",
                    }}
                ></i>
            </div>
            <div>
                {isActive &&
                    createPortal(
                        <div
                            style={{
                                position: "fixed",
                                zIndex: 9999,
                                left: "50%",
                                top: "50%",
                                width: "30%",
                                transform: "translate(-50%, -50%)",
                            }}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    background: "white",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                    backgroundColor: "#A70000",
                                }}
                            >
                                <Select
                                    options={options}
                                    isMulti
                                    value={options.filter((option) =>
                                        filterValue?.includes(option.value)
                                    )}
                                    onChange={handleMultiSelectChange}
                                    isClearable
                                    isSearchable
                                    placeholder={`Filter ${id}`}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                                <button
                                    style={{
                                        marginTop: "10px",
                                        marginLeft: "150px",
                                        padding: "5px 10px",
                                        background: "#007bff",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setIsActive(false)} // Close the popup
                                >
                                    Close
                                </button>
                            </div>
                        </div>,
                        document.body
                    )}
            </div>
        </div>
    );
};





function Intern_fileupload() {

    const [responseData, setResponseData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isUpdateshowModal, setUpdateShowModal] = useState(false);
    const [ispreviewshowModal, setpreviewShowModal] = useState(false);
    const [branch, setbranch] = useState([]);
    const [role_id, setroleid] = useState("");
    const [previllages, setprevillages] = useState({});
    const navigate = useNavigate();
    const [addData, setAddData] = useState({
        branch_id: "",
        type: "",
        full_name: "",
        gender: "",
        contact: "",
        email_address: "",
        course_department: "",
        year_of_study: "",
        // roll_number: '',
        year_of_passout: "",
        Institution_name: "",
        preferred_training: "",

        from_date: "",
        to_date: "",
        no_of_days: "",
        fees: "",
        domain: "",
        other_details: ""
    });

    const [updateData, setUpdateData] = useState({
        branch_id: "",
        type: "",
        full_name: "",
        gender: "",
        contact: "",
        email_address: "",
        course_department: "",
        year_of_study: "",
        // roll_number: '',
        year_of_passout: "",
        Institution_name: "",
        preferred_training: "",

        from_date: "",
        to_date: "",
        no_of_days: "",
        fees: "",
        domain: "",
        other_details: ""
    });

    useEffect(() => {
        fetchData();
        fetchDataed();
        gettoken();
        getprevillages();
        window.scrollTo(0, 0);
    }, []);

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, []);





    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + "/internship", {
                params: { data: localStorage.getItem("branch_id") },
            });


            console.log("Response from server:", response.data);
            if (response && response.status === 200) {
                setTimeout(() => {
                    setLoading(false);
                }, 300);
            }
            setResponseData(response.data.reverse());



        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    const fetchDataed = async () => {
        try {
            const response = await axios.get(apiUrl + "/Branch");
            console.log("Response from server:", response.data);
            setbranch(response.data);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    const gettoken = async () => {
        const token = localStorage.getItem("token");

        try {
            const response = await axios.post(apiUrl + "/get_detail", {
                token: token,
            });
            console.log("token detail from server:", response.data);

            setroleid(response.data.detail.rolename);

            localStorage.setItem("role_id", response.data.detail.rolename);

            const id = response.data.detail.rolename;

            if (id) {
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };
    const getprevillages = () => {
        const username = JSON.parse(localStorage.getItem("user_previllages"));
        console.log("tyhe username get by local stroage : ", username.modules);
        const total_previlages = username.modules;
        const new_enquiry = total_previlages.find(
            (item) => item.name == "Student Database"
        );
        console.log("the new_enquiry is : ", new_enquiry.actions);

        setprevillages(new_enquiry.actions);
    };

    // const handleNewButtonClick = () => {
    //     if (previllages.add || previllages.all) {
    //     setShowModal(true);
    // }else{
    //     toast.error("You don't have the permission to add");
    // }
    // }

    const handlesubmit = async (e) => {
        e.preventDefault();

        // if (!validateFields()) {
        //   return;
        // }
        try {
            setLoading(true);
            const formData = {
                branch_id: addData.branch_id,
                type: addData.type,
                full_name: addData.full_name,
                gender: addData.gender,
                contact: addData.contact,
                email_address: addData.email_address,
                course_department: addData.course_department,
                year_of_study: addData.year_of_study,
                // roll_number: addData.roll_number,
                year_of_passout: addData.year_of_passout,
                Institution_name: addData.Institution_name,
                preferred_training: addData.preferred_training,

                from_date: addData.from_date,
                to_date: addData.to_date,
                no_of_days: addData.no_of_days,
                fees: addData.fees,
                domain: addData.domain,
                other_details: addData.other_details,
            };
            const response = await axios.post(apiUrl + "/internship", formData);

            //   alert(response.data.message); // Show success message
            console.log("added post:", response);
            setShowModal(false);
            toast.success("added successfully!");
            setAddData({
                branch_id: "",
                type: "",
                full_name: "",
                gender: "",
                contact: "",
                email_address: "",
                course_department: "",
                year_of_study: "",
                // roll_number: '',
                year_of_passout: "",
                Institution_name: "",
                preferred_training: "",
                from_date: "",
                to_date: "",
                no_of_days: "",
                fees: "",
                domain: "",
                other_details: "",
            });
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            fetchData();
        } catch (error) {
            console.error("Error updating data:", error.message);
        }
    };

    const [updateid, setUpdateId] = useState("");

    const handleUpdate = (_id, data) => {
        if (previllages.edit || previllages.all) {
            setUpdateId(_id);
            console.log(" the data to updata", data);
            setUpdateShowModal(true);
            setUpdateData({
                branch_id: data.branch_id,
                type: data.type,
                full_name: data.full_name,
                gender: data.gender,
                contact: data.contact,
                email_address: data.email_address,
                course_department: data.course_department,
                year_of_study: data.year_of_study,
                // roll_number: data.roll_number,
                year_of_passout: data.year_of_passout,
                Institution_name: data.Institution_name,
                preferred_training: data.preferred_training,
                from_date: data.from_date,
                to_date: data.to_date,
                no_of_days: data.no_of_days,
                fees: data.fees,
                domain: data.domain,
                other_details: data.other_details
            });
        } else {
            toast.error("You don't have the permission to update");
        }
    };

    const handlepreview = (_id, data) => {
        setUpdateId(_id);
        console.log(" the data to updata", data);
        setpreviewShowModal(true);
        setUpdateData({
            branch_id: data.branch_id,
            type: data.type,
            full_name: data.full_name,
            gender: data.gender,
            contact: data.contact,
            email_address: data.email_address,
            course_department: data.course_department,
            year_of_study: data.year_of_study,
            year_of_passout: data.year_of_passout,
            // roll_number: data.roll_number,
            Institution_name: data.Institution_name,
            preferred_training: data.preferred_training,
            from_date: data.from_date,
            to_date: data.to_date,
            no_of_days: data.no_of_days,
            fees: data.fees,
            domain: data.domain,
            other_details: data.other_details
        });
    };

    const handleupdatesubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const formData = {
                branch_id: updateData.branch_id,
                type: updateData.type,
                full_name: updateData.full_name,
                gender: updateData.gender,
                contact: updateData.contact,
                email_address: updateData.email_address,
                course_department: updateData.course_department,
                year_of_study: updateData.year_of_study,
                // roll_number: updateData.roll_number,
                year_of_passout: updateData.year_of_passout,
                Institution_name: updateData.Institution_name,
                preferred_training: updateData.preferred_training,
                from_date: updateData.from_date,
                to_date: updateData.to_date,
                no_of_days: updateData.no_of_days,
                fees: updateData.fees,
                domain: updateData.domain,
                other_details: updateData.other_details
            };
            console.log("the update submit data", formData);
            const response = await axios.put(
                apiUrl + `/internship/${updateid}`,
                formData
            );
            console.log("response for update", response);
            setUpdateShowModal(false);
            toast.success("Update successfully!");
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            fetchData();
        } catch (error) {
            console.error("Error updating data:", error.message);
        }
    };

    const handleDelete = async (id) => {
        try {
            // setLoading(true);
            const response = await axios.delete(
                apiUrl + `/internship/${getdeleteid}`
            );
            console.log("delete data ", response);
            toast.error("Delete successfully!");
            setDeleteShowModals(false);
            // setTimeout(() => {
            //   setLoading(false);
            // }, 500);
            fetchData();
        } catch (error) {
            console.error("Error updating data:", error.message);
        }
    };

    const [deleteShowModals, setDeleteShowModals] = useState(false);
    const handleCloseModal = () => {
        setDeleteShowModals(false);
    };

    const [getdeleteid, setdeleteid] = useState("");

    const [getdeletename, setdeletename] = useState("");
    const handleOpenModal = (_id, full_name) => {

        console.log(" the id", _id);
        console.log(" the name", full_name);
        setdeleteid(_id);
        setdeletename(full_name);
        setDeleteShowModals(true);

    };

    const [errors, setErrors] = useState({});

    //   from_date: updateData.from_date,
    //   to_date: updateData.to_date,
    //   no_of_days: updateData.no_of_days,
    //   fees: updateData.fees,

    const validateFields = () => {
        let tempErrors = {};
        let isValid = true;

        if (!addData.branch_id) {
            tempErrors.branch_id = "branch is required.";
            isValid = false;
        }

        if (!addData.type) {
            tempErrors.type = "Type is required.";
            isValid = false;
        }

        if (!addData.full_name) {
            tempErrors.full_name = "Name is required.";
            isValid = false;
        }

        if (!addData.gender) {
            tempErrors.gender = "Gender is required.";
            isValid = false;
        }

        if (!/^\d{10}$/.test(addData.contact)) {
            tempErrors.contact = "Mobile number must be 10 digits.";
            isValid = false;
        }

        if (!addData.email_address) {
            tempErrors.email_address = "Email is required.";
            isValid = false;
        }
        if (
            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addData.email)
        ) {
            tempErrors.email_address = "Please enter a valid email address.";
            isValid = false;
        }

        if (!addData.course_department) {
            tempErrors.course_department = "Course department is required.";
            isValid = false;
        }

        if (!addData.year_of_study) {
            tempErrors.year_of_study = "Year of study is required.";
            isValid = false;
        }

        if (!addData.year_of_passout) {
            tempErrors.year_of_passout = "Year of Passout  is required.";
            isValid = false;
        }

        if (!addData.Institution_name) {
            tempErrors.Institution_name = "Institution Name is required.";
            isValid = false;
        }

        if (!addData.Institution_name) {
            tempErrors.Institution_name = "Institution Name is required.";
            isValid = false;
        }

        if (!addData.preferred_training) {
            tempErrors.preferred_training = "Preferred training is required.";
            isValid = false;
        }

        if (!addData.domain) {
            tempErrors.domain = "Domain is required.";
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    // the pagination ---------------------------------------------------------------------
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Search
    const filtered = currentItems.filter((item) =>
        Object.values(item).some(
            (value) =>
                (typeof value === "string" &&
                    value.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (typeof value === "number" && value.toString().includes(searchQuery))
        )
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(responseData.length / itemsPerPage);

    const goToNextPage = () => {
        setCurrentPage((prevPage) =>
            prevPage === totalPages ? prevPage : prevPage + 1
        );
    };

    const goToPrevPage = () => {
        setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
    };
    // the pagination  end ---------------------------------------------------------------------
    // const createPagination = () => {
    //   let liTag = [];
    //   let beforePage = currentPage - 1;
    //   let afterPage = currentPage + 1;
    //   let active;

    //   if (currentPage > 1) {
    //     liTag.push(
    //       <li className="page-item" key="prev">
    //         <button
    //           className="page-link"
    //           onClick={() => paginate(currentPage - 1)}
    //         >
    //           <FaAngleLeft /> Prev
    //         </button>
    //       </li>
    //     );
    //   }

    //   if (currentPage > 2) {
    //     liTag.push(
    //       <li className="page-item" key="first" onClick={() => paginate(1)}>
    //         <button className="page-link">1</button>
    //       </li>
    //     );
    //     if (currentPage > 3) {
    //       liTag.push(
    //         <li className="page-item disabled" key="dots1">
    //           <span className="page-link">...</span>
    //         </li>
    //       );
    //     }
    //   }

    //   if (currentPage === totalPages) {
    //     beforePage -= 2;
    //   } else if (currentPage === totalPages - 1) {
    //     beforePage -= 1;
    //   }

    //   if (currentPage === 1) {
    //     afterPage += 2;
    //   } else if (currentPage === 2) {
    //     afterPage += 1;
    //   }

    //   for (let plength = beforePage; plength <= afterPage; plength++) {
    //     if (plength > totalPages || plength <= 0) continue;
    //     active = currentPage === plength ? "active" : "";
    //     liTag.push(
    //       <li
    //         className={`page-item ${active}`}
    //         key={plength}
    //         onClick={() => paginate(plength)}
    //       >
    //         <button className="page-link">{plength}</button>
    //       </li>
    //     );
    //   }

    //   if (currentPage < totalPages - 1) {
    //     if (currentPage < totalPages - 2) {
    //       liTag.push(
    //         <li className="page-item disabled" key="dots2">
    //           <span className="page-link">...</span>
    //         </li>
    //       );
    //     }
    //     liTag.push(
    //       <li
    //         className="page-item"
    //         key="last"
    //         onClick={() => paginate(totalPages)}
    //       >
    //         <button className="page-link">{totalPages}</button>
    //       </li>
    //     );
    //   }

    //   if (currentPage < totalPages) {
    //     liTag.push(
    //       <li className="page-item" key="next">
    //         <button
    //           className="page-link"
    //           onClick={() => paginate(currentPage + 1)}
    //         >
    //           Next <FaAngleRight />
    //         </button>
    //       </li>
    //     );
    //   }

    //   return liTag;
    // };



    const createPagination = () => {
        let liTag = [];
        let totalPages = pageCount; // Total pages
        let currentPage = state.pageIndex;
        let active;

        // Previous Page Button
        liTag.push(
            <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
                <button
                    className="page-link"
                    onClick={() => gotoPage(currentPage - 1)}
                    disabled={!canPreviousPage}
                >
                    <FaAngleLeft /> Prev
                </button>
            </li>
        );

        // Always show first page
        if (totalPages > 1) {
            liTag.push(
                <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
                    <button className="page-link" onClick={() => gotoPage(0)}>
                        1
                    </button>
                </li>
            );
        }

        // Show second page if total pages > 2
        if (totalPages > 2) {
            liTag.push(
                <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
                    <button className="page-link" onClick={() => gotoPage(1)}>
                        2
                    </button>
                </li>
            );
        }

        // Add "..." before current page group
        if (currentPage > 3) {
            liTag.push(
                <li className="page-item disabled" key="dot-prev">
                    <span className="page-link">...</span>
                </li>
            );
        }

        // Show 3 pages around current page
        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
            active = currentPage === i ? "active" : "";
            liTag.push(
                <li className={`page-item ${active}`} key={i}>
                    <button className="page-link" onClick={() => gotoPage(i)}>
                        {i + 1}
                    </button>
                </li>
            );
        }

        // Add "..." after current page group
        if (currentPage < totalPages - 4) {
            liTag.push(
                <li className="page-item disabled" key="dot-next">
                    <span className="page-link">...</span>
                </li>
            );
        }

        // Always show last two pages if totalPages > 2
        if (totalPages > 2) {
            liTag.push(
                <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
                    <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
                        {totalPages - 1}
                    </button>
                </li>
            );
        }

        if (totalPages > 1) {
            liTag.push(
                <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
                    <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
                        {totalPages}
                    </button>
                </li>
            );
        }

        // Next Page Button
        liTag.push(
            <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
                <button
                    className="page-link"
                    onClick={() => gotoPage(currentPage + 1)}
                    disabled={!canNextPage}
                >
                    Next <FaAngleRight />
                </button>
            </li>
        );

        return liTag;
    };





    // ========================================
    const formatDatefitching = (isoDate) => {
        if (!isoDate) return ""; // Return an empty string if no date is provided
        const date = new Date(isoDate);
        return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return ""; // Return an empty string if no date is provided
        const date = new Date(isoDate);

        const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
        const year = date.getFullYear();

        return `${day}-${month}-${year}`; // Format as "day-month-year"
    };
    const [datafile, setDataFile] = useState([]);
    const [loading, setLoading] = useState(false);

    const data = useMemo(() => {
        return datafile.map((item) => ({
            _id: item._id,
            // branch_id: {
            //     _id: item.branch_id?._id ?? null,
            //     branch_name: item.branch_id?.branch_name ?? "",
            // },

            branch_id: item.branch_id,
            type: item.type,
            full_name: item.Institution_name,
            gender: item.gender,
            contact: item.contact,
            email_address: item.email_address,
            course_department: item.course_department,
            year_of_study: item.year_of_study,
            roll_number: item.roll_number,
            Institution_name: item.Institution_name,
            preferred_training: item.preferred_training,
            year_of_passout: item.year_of_passout,
            from_date: item.from_date,
            no_of_days: item.no_of_days,
            fees: item.fees,
            domain: item.domain,
            other_details: item.other_details




        }));
    }, [datafile]);


    const [rolename, setrolename] = useState([]);
    useEffect(() => {
        const branchName = localStorage.getItem("branch_name");
        setrolename(branchName);
    }, []);



    const columns = useMemo(() => {
        const baseColumns = [
            {
                Header: "S.No",
                id: "serialNo",
                Cell: ({ row }) => {
                    return row.index + 1;
                },
            },
            {
                Header: "Branch",
                accessor: "branch_id",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Type",
                accessor: "type",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Name",
                accessor: "full_name",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Mobile",
                accessor: "contact",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Course",
                accessor: "preferred_training",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
        ];



        return baseColumns;
    }, [rolename]); // Recalculate when rolename changes


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state,
        setGlobalFilter,
        setPageSize,
        page,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
    } = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 10 },
            defaultColumn: { Filter: DefaultColumnFilter },
            filterTypes: {
                multiSelectFilter: (rows, columnIds, filterValue) => {
                    if (!filterValue || filterValue.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => {
                        const rowValue = row.values[columnIds[0]];
                        const rowValueStr = String(rowValue);
                        return filterValue.some((filterVal) =>
                            rowValueStr.includes(String(filterVal))
                        );
                    });
                },
            },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );






    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const parsedData = XLSX.utils.sheet_to_json(sheet);
            setDataFile(parsedData);
            console.log(parsedData, "parsedData");
        };


        reader.readAsBinaryString(file);
    };


    const handleAdd = async () => {
        console.log("Uploaded Data before upload:", datafile);

        if (datafile.length === 0) {
            toast.error("No enquiries to upload.");
            return;
        }



        try {
            // Don't redeclare uploadedData here, just use the state value
            const response = await axios.post(`${apiUrl}/intershipupload`, { intership: datafile });
            console.log("Student Database successfully!", response.data);
            if (response.status == 201) {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }



            toast.success("Student Database uploaded successfully!");
            navigate(`/Studentdatabase`);

        } catch (error) {
            console.error("Error posting enquiries:", error);
            // toast.error("Failed to upload enquiries.");
            if (error.response && error.response.status === 400) {
                toast.error("Internship with the same email and contact already exists ");
            } else {
                toast.error("Failed to upload enquiries.");
            }
        }

    };


    const handleDownload = () => {
        // Create a link element
        const link = document.createElement("a");
        link.href = excelFile;
        link.download = "downloaded-file-name.xlsx"; // The name that the downloaded file will have
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };




    return (

        <>
            {loading === true ? (
                <div className="loading-overlay">
                    <div className="loading-message">
                        <img
                            className="loadinggif"
                            src={require("../../assets/img/output-onlinegiftools.gif")}
                        />{" "}
                    </div>
                </div>
            ) : (
                <div className="d-none"></div>
            )}
            <div className="top">
                <div className="" style={{ marginTop: "-80px" }}>
                    <div className="row mb-3">
                        <div className="col-lg-8">
                            <Link to="/dashboard" className="text-secondary dashBoard_text">
                                <b>Dashboard / </b>
                            </Link>
                            <Link to="/Studentdatabase" className="text-secondary dashBoard_text">
                                <b>Student Database / </b>
                            </Link>

                            <Link to="" className="text-danger dashBoard_text">
                                <b>Student Database Fileupload</b>
                            </Link>

                        </div>
                        <div className="col-lg-4 d-flex justify-content-between">
                            <div>
                                <button onClick={handleDownload} className="btn btn-primary">
                                    Excel <i class="fa-solid fa-cloud-arrow-down text-white"></i>
                                </button>
                            </div>
                            <div className="ms-3">
                                <input
                                    type="file"
                                    id="file-upload"
                                    accept=".xls,.xlsx"
                                    style={{ display: "none" }}
                                    onChange={handleFileUpload}
                                />
                                <label htmlFor="file-upload" className="btn btn-secondary">
                                    File Upload
                                </label>

                            </div>
                            <div className="mx-2">
                                <button className="btn btn-success add mx-3" onClick={handleAdd}>
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </div>




                {/* <div className="row">
                    
                    <div className="col-lg-3">
                    </div>

                </div> */}



                <div className="mb-3 mt-3">
                    <div className="row">
                        <div className="col-lg-7 col-md-4 col-sm-1">
                            <div className="d-flex">
                                <h5 className="mt-2">Student Database File Upload</h5>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-between">
                            
                        {/* </div>

                        <div className="col-lg-3 col-md-4 col-sm-7"> */}
                            <div className="w-full flex-1 ms-5 ps-3">
                                <form>
                                    <div className="relative">
                                        <input
                                            className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                                            placeholder="Search ..."
                                            type="search"
                                            value={state.globalFilter || ""} // Use the globalFilter value
                                            onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className="d-flex me-2">
                                <label className="form-label text-dark mt-1">Show : </label>
                            <div>
                                <select
                                    className="form-control w-100 mx-2"
                                    value={state.pageSize}
                                    onChange={(e) => setPageSize(Number(e.target.value))}
                                >
                                    {[10, 20, 50].map((pageSize) => (
                                        <option key={pageSize} value={pageSize}>
                                            {pageSize}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>






                <Table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <Th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                    >
                                        <div className="d-flex">
                                            <div className="mx-2">{column.render("Header")}</div>
                                            <div>
                                                {column.canFilter ? column.render("Filter") : null}
                                            </div>
                                            <div className="mx-1">
                                                {column.isSorted
                                                    ? column.isSortedDesc
                                                        ? " 🔽"
                                                        : " 🔼"
                                                    : ""}
                                            </div>
                                        </div>
                                    </Th>
                                ))}
                                <Th className="text-center">Action</Th>
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => (
                                        <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                                    ))}
                                    <Td className="text-center">
                                        {previllages.edit && (
                                            <button
                                                className="btn updelete mx-2"
                                                onClick={() =>
                                                    handleUpdate(row.original._id, row.original)
                                                }
                                            >
                                                <i className="fa-solid fa-pen-to-square"></i>
                                            </button>
                                        )}

                                        {previllages.delete && (
                                            <button
                                                className="btn delete"
                                                onClick={() =>
                                                    handleOpenModal(
                                                        row.original._id,
                                                        row.original.full_name
                                                    )
                                                }
                                            >
                                                <i className="fa-solid fa-trash-can"></i>
                                            </button>
                                        )}



                                        <button
                                            className="btn updelete mx-2"
                                            onClick={() =>
                                                handlepreview(row.original._id, row.original)
                                            }
                                        >
                                            <i className="fa-solid fa-circle-info"></i>
                                        </button>
                                    </Td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>


                {/* Modal for adding a new user */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Add Student Database</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={addData.branch_id._id}
                                            placeholder=""
                                            onChange={(e) =>
                                                setAddData({ ...addData, branch_id: e.target.value })
                                            }
                                        >
                                            <option value="">Select Branch</option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={addData.branch_id ? "filled" : ""}>
                                            Select Branch
                                        </label>
                                        {errors.branch_id && (
                                            <div className="error-text">{errors.branch_id}</div>
                                        )}
                                    </div>


                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={addData.type}
                                            onChange={(e) =>
                                                setAddData({ ...addData, type: e.target.value })
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Training">Corporate Training</option>
                                            <option value="College Project">College Project</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <label className={addData.type ? "filled" : ""}>Select Type</label>

                                        {errors.type && <div className="error-text">{errors.type}</div>}

                                        {/* Show the other_details field only if "Others" is selected */}
                                        {addData.type === "Others" && (
                                            <div className="floating-label">
                                                <input
                                                    type="text"
                                                    className="form-control mt-2"
                                                    placeholder="Please specify"
                                                    value={addData.other_details || ""}
                                                    onChange={(e) =>
                                                        setAddData({ ...addData, other_details: e.target.value })
                                                    }
                                                />
                                                <label className={addData.other_details ? "filled" : ""}>
                                                    Other Details
                                                </label>
                                                {/* {errors.other_details && <div className="error-text">{errors.other_details}</div>} */}
                                            </div>
                                        )}
                                    </div>







                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.full_name}
                                            onChange={(e) =>
                                                setAddData({ ...addData, full_name: e.target.value })
                                            }
                                            required
                                        />
                                        <label className={addData.full_name ? "filled" : ""}>
                                            Full Name
                                        </label>
                                        {errors.full_name && (
                                            <div className="error-text">{errors.full_name}</div>
                                        )}
                                    </div>


                                    <div className="floating-label">
                                        <select
                                            className="form-select"
                                            value={addData.gender}
                                            // onChange={handleBranch}
                                            onChange={(e) =>
                                                setAddData({ ...addData, gender: e.target.value })
                                            }
                                        >
                                            <option value="" disabled>
                                                Select Gender
                                            </option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Transgender">Transgender</option>
                                        </select>
                                        {/* <label className={addData.gender ? "filled" : ""}></label> */}
                                        {errors.gender && (
                                            <div className="error-text">{errors.gender}</div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.contact}
                                            onChange={(e) =>
                                                setAddData({ ...addData, contact: e.target.value })
                                            }
                                            required
                                        />
                                        <label className={addData.contact ? "filled" : ""}>
                                            Contact
                                        </label>
                                        {errors.contact && (
                                            <div className="error-text">{errors.contact}</div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="email"
                                            value={addData.email_address}
                                            onChange={(e) =>
                                                setAddData({
                                                    ...addData,
                                                    email_address: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={addData.email_address ? "filled" : ""}>
                                            Email Address
                                        </label>
                                        {/* {errors.email_address && (
                          <div className="error-text">{errors.email_address}</div>
                        )} */}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.course_department}
                                            onChange={(e) =>
                                                setAddData({
                                                    ...addData,
                                                    course_department: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={addData.course_department ? "filled" : ""}
                                        >
                                            Course Department
                                        </label>
                                        {errors.course_department && (
                                            <div className="error-text">
                                                {errors.course_department}
                                            </div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.year_of_passout}
                                            onChange={(e) =>
                                                setAddData({
                                                    ...addData,
                                                    year_of_passout: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={addData.year_of_passout ? "filled" : ""}>
                                            year of passout
                                        </label>
                                        {errors.year_of_passout && (
                                            <div className="error-text">{errors.year_of_passout}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={addData.year_of_study}
                                            placeholder=""
                                            // onChange={handleBranch}
                                            onChange={(e) =>
                                                setAddData({
                                                    ...addData,
                                                    year_of_study: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="">Select Year</option>
                                            <option value="1st Year">1st Year</option>
                                            <option value="2nd Year">2nd Year</option>
                                            <option value="3rd Year">3rd Year</option>
                                            <option value="4th Year">4th Year</option>
                                        </select>
                                        <label className={addData.year_of_study ? "filled" : ""}>
                                            Year Of Study
                                        </label>
                                        {errors.year_of_study && (
                                            <div className="error-text">{errors.year_of_study}</div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.Institution_name}
                                            onChange={(e) =>
                                                setAddData({
                                                    ...addData,
                                                    Institution_name: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={addData.Institution_name ? "filled" : ""}>
                                            Institution Name
                                        </label>
                                        {errors.Institution_name && (
                                            <div className="error-text">
                                                {errors.Institution_name}
                                            </div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.preferred_training}
                                            onChange={(e) =>
                                                setAddData({
                                                    ...addData,
                                                    preferred_training: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={addData.preferred_training ? "filled" : ""}
                                        >
                                            Preferred Training
                                        </label>
                                        {errors.preferred_training && (
                                            <div className="error-text">
                                                {errors.preferred_training}
                                            </div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.domain}
                                            onChange={(e) =>
                                                setAddData({ ...addData, domain: e.target.value })
                                            }
                                            required
                                        />
                                        <label className={addData.domain ? "filled" : ""}>
                                            Domain
                                        </label>
                                        {errors.domain && (
                                            <div className="error-text">{errors.domain}</div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="date"
                                            value={addData.from_date}
                                            onChange={(e) =>
                                                setAddData({ ...addData, from_date: e.target.value })
                                            }
                                            required
                                        />
                                        <label className={addData.from_date ? "filled" : ""}>
                                            Date
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.no_of_days}
                                            onChange={(e) =>
                                                setAddData({
                                                    ...addData,
                                                    no_of_days: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={addData.no_of_days ? "filled" : ""}>
                                            Location
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <textarea
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.fees}
                                            onChange={(e) =>
                                                setAddData({ ...addData, fees: e.target.value })
                                            }
                                            required
                                        />
                                        <label className={addData.fees ? "filled" : ""}>
                                            Notes
                                        </label>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            className="cancelbut"
                            variant="secondary"
                            onClick={() => setShowModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="submitbut"
                            variant="primary"
                            onClick={handlesubmit}
                        >
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={isUpdateshowModal}
                    onHide={() => setUpdateShowModal(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Update Student Database</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Other input fields */}

                        <div className="form-group">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="floating-label">
                                        <select
                                            className="form-select"
                                            value={updateData.branch_id._id}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    branch_id: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="">Select Brand</option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label
                                            className={
                                                updateData.branch_id.branch_name ? "filled" : ""
                                            }
                                        ></label>
                                    </div>



                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.type}
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, type: e.target.value })
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Training">Corporate Training</option>
                                            <option value="College Project">College Project</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <label className={updateData.type ? "filled" : ""}>Select Type</label>

                                        {/* Show the other_details field only if "Others" is selected */}
                                        {updateData.type === "Others" && (
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                placeholder="Please specify"
                                                value={updateData.other_details || ""}
                                                onChange={(e) =>
                                                    setUpdateData({ ...updateData, other_details: e.target.value })
                                                }
                                            />
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.full_name}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    full_name: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.full_name ? "filled" : ""}>
                                            Full Name
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <select
                                            className="form-select"
                                            value={updateData.gender}
                                            placeholder=""
                                            // onChange={handleBranch}
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, gender: e.target.value })
                                            }
                                        >
                                            <option value="" disabled>
                                                Select Gender
                                            </option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Transgender">Transgender</option>
                                        </select>
                                        <label className={updateData.gender ? "filled" : ""}>
                                            Gender
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.contact}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    contact: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.contact ? "filled" : ""}>
                                            Contact
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.email_address}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    email_address: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.email_address ? "filled" : ""}>
                                            Email Address
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.course_department}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    course_department: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.course_department ? "filled" : ""}
                                        >
                                            Course Department
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.year_of_passout}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    year_of_passout: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.year_of_passout ? "filled" : ""}>
                                            Year of Passout
                                        </label>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.year_of_study}
                                            placeholder=""
                                            // onChange={handleBranch}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    year_of_study: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="" disabled>
                                                Select Year
                                            </option>
                                            <option value="1st Year">1st Year</option>
                                            <option value="2nd Year">2nd Year</option>
                                            <option value="3rd Year">3rd Year</option>
                                            <option value="4th Year">4th Year</option>
                                        </select>
                                        <label
                                            className={updateData.year_of_study ? "filled" : ""}
                                        ></label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.Institution_name}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    Institution_name: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.Institution_name ? "filled" : ""}
                                        >
                                            Institution Name
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.preferred_training}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    preferred_training: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.preferred_training ? "filled" : ""}
                                        >
                                            Preferred Training
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.domain}
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, domain: e.target.value })
                                            }
                                            required
                                        />
                                        <label className={updateData.domain ? "filled" : ""}>
                                            Domain
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="date"
                                            placeholder=""
                                            value={formatDatefitching(updateData.from_date)}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    from_date: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.from_date ? "filled" : ""}>
                                            Date
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.no_of_days}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    no_of_days: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.no_of_days ? "filled" : ""}
                                        >
                                            Location
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <textarea
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            value={updateData.fees}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    fees: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.fees ? "filled" : ""}>
                                            Notes
                                        </label>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            className="cancelbut"
                            variant="secondary"
                            onClick={() => setUpdateShowModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="submitbut"
                            variant="primary"
                            onClick={handleupdatesubmit}
                        >
                            Update
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={ispreviewshowModal}
                    onHide={() => setpreviewShowModal(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Preview Student Database</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Other input fields */}

                        <div className="form-group">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="floating-label">
                                        <select
                                            className="form-select"
                                            value={updateData.branch_id._id}
                                            disabled
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    branch_id: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="">Select Brand Id</option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label
                                            className={
                                                updateData.branch_id.branch_name ? "filled" : ""
                                            }
                                        ></label>
                                    </div>


                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.type}
                                            disabled
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, type: e.target.value })
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Training">Corporate Training</option>
                                            <option value="College Project">College Project</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <label className={updateData.type ? "filled" : ""}>Select Type</label>

                                        {/* Show the other_details field only if "Others" is selected */}
                                        {updateData.type === "Others" && (
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control mt-2"
                                                placeholder="Please specify"
                                                value={updateData.other_details || ""}
                                                onChange={(e) =>
                                                    setUpdateData({ ...updateData, other_details: e.target.value })
                                                }
                                            />
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.full_name}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    full_name: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.full_name ? "filled" : ""}>
                                            Full Name
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <select
                                            className="form-select"
                                            value={updateData.gender}
                                            placeholder=""
                                            disabled
                                            // onChange={handleBranch}
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, gender: e.target.value })
                                            }
                                        >
                                            <option value="" disabled>
                                                Select Gender
                                            </option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Transgender">Transgender</option>
                                        </select>
                                        <label className={updateData.gender ? "filled" : ""}>
                                            Gender
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.contact}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    contact: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.contact ? "filled" : ""}>
                                            Contact
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.email_address}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    email_address: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.email_address ? "filled" : ""}>
                                            Email Address
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.course_department}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    course_department: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.course_department ? "filled" : ""}
                                        >
                                            Course Department
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.year_of_passout}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    year_of_passout: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.year_of_passout ? "filled" : ""}
                                        >
                                            Year Of Passout
                                        </label>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.year_of_study}
                                            placeholder=""
                                            disabled
                                            // onChange={handleBranch}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    year_of_study: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="" disabled>
                                                Select Year
                                            </option>
                                            <option value="1st Year">1st Year</option>
                                            <option value="2nd Year">2nd Year</option>
                                            <option value="3rd Year">3rd Year</option>
                                            <option value="4th Year">4th Year</option>
                                        </select>
                                        <label
                                            className={updateData.year_of_study ? "filled" : ""}
                                        ></label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.Institution_name}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    Institution_name: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.Institution_name ? "filled" : ""}
                                        >
                                            Institution Name
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.preferred_training}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    preferred_training: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.preferred_training ? "filled" : ""}
                                        >
                                            Preferred Training
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.domain}
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, domain: e.target.value })
                                            }
                                            required
                                        />
                                        <label className={updateData.domain ? "filled" : ""}>
                                            Domain
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="date"
                                            placeholder=""
                                            disabled
                                            value={formatDatefitching(updateData.from_date)}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    from_date: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.from_date ? "filled" : ""}>
                                            Date
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.no_of_days}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    no_of_days: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.no_of_days ? "filled" : ""}
                                        >
                                            Location
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <textarea
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            disabled
                                            value={updateData.fees}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    fees: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label className={updateData.fees ? "filled" : ""}>
                                            Notes
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            className="cancelbut"
                            variant="secondary"
                            onClick={() => setpreviewShowModal(false)}
                        >
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* ----------------delete */}

                <Modal
                    className="modal"
                    show={deleteShowModals}
                    onHide={handleCloseModal}
                >
                    <Modal.Header>
                        <p id="modeti">Are you sure you want to Delete?</p>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="form-label d-flex">
                            <h5 className="mx-1">Name :</h5>{" "}
                            <h5>{getdeletename} </h5>
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="cancelbut"
                            variant="secondary"
                            onClick={handleCloseModal}
                        >
                            Close
                        </Button>
                        <Button
                            className="submitbut"
                            variant="primary"
                            onClick={handleDelete}
                        >
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* _------------------------------pagination button -------------------------------- */}

                <div className="mt-3 pb-5">
                    <div className="row">
                        <div className="col-lg-7 col-sm-12 mt-1">
                            <span className="text-dark">
                                Page {state.pageIndex + 1} of {pageCount}
                            </span>
                        </div>
                        <div className="col-lg-5">
                            <div className="mt-3 pb-5">
                                <nav>
                                    <ul className="pagination justify-content-center">
                                        {createPagination()} {/* Pagination buttons */}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ---------------------------------------end ---------------------------------- */}
            </div>
        </>
    );
}

export default Intern_fileupload
